import { z } from 'zod';

/**
 * Wire do `GET /flight/airports?q`: o BFF devolve, a página de voo do web-chat lê
 * na borda. Fica no domain porque as duas pontas validam o mesmo formato.
 */
export const AirportSchema = z.object({
  iata: z.string().min(1),
  name: z.string(),
  countryName: z.string(),
  countryCode: z.string(),
});
export type Airport = z.infer<typeof AirportSchema>;

export const AirportsResponseSchema = z.object({ items: z.array(AirportSchema) });

/**
 * Wire do `GET /flight/airports/history`. Mesma `Airport` do `GET /flight/airports?q`:
 * o cliente NÃO aprende um segundo formato de aeroporto, só um segundo jeito de obter
 * a lista.
 *
 * São DOIS conjuntos (o backend guarda origem e destino separados), na ordem que
 * o backend devolve. Ambos podem vir vazios — o histórico é conveniência.
 */
export const AirportHistoryResponseSchema = z.object({
  origin: z.array(AirportSchema),
  destination: z.array(AirportSchema),
});
export type AirportHistory = z.infer<typeof AirportHistoryResponseSchema>;
